import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Adds the sign-in token to API calls that do not set one themselves. Most screens go through
 * HttpService (which sets it); some reports call HttpClient directly with '/api/...' and were sent
 * without a token (401). Nothing else is changed.
 */
export const apiTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = sessionStorage.getItem('token');
  const isApi = req.url.startsWith('/api/') || req.url.startsWith(environment.apiUrl);
  if (!token || !isApi || req.headers.has('Authorization')) return next(req);
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
